module.exports = __webpack_public_path__ + "img/print-icon.9f9a188e.svg";